import { render, staticRenderFns } from "./TitleImg.vue?vue&type=template&id=504c1f29&scoped=true"
import script from "./TitleImg.vue?vue&type=script&lang=js"
export * from "./TitleImg.vue?vue&type=script&lang=js"
import style0 from "./TitleImg.vue?vue&type=style&index=0&id=504c1f29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504c1f29",
  null
  
)

export default component.exports